import React from 'react';
import { CircularProgress, Button } from '@mui/material';
import PropTypes from 'prop-types';

//TODO: start adorment option later
export default function SpinnerButton(props) {
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ position: 'relative', ...(props.fullWidth ? { width: '100%' } : {}) }}>
                <Button
                    variant="contained"
                    color="secondary"
                    sx={props.fullWidth ? { width: '95%' } : undefined}
                    disabled={props.inProgress}
                    onClick={props.onClick}>
                    {props.text}
                </Button>
                {props.inProgress && (
                    <CircularProgress
                        size={24}
                        sx={{
                            color: 'secondary.main',
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            mt: '-12px',
                            ml: '-12px',
                        }}
                    />
                )}
            </div>
        </div>
    );
}

SpinnerButton.propTypes = {
    inProgress: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    fullWidth: PropTypes.bool,
};
